/**
 * @generated SignedSource<<616698460f806b6a2082506c756ea6ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponentVideo_componentModule$data = {
  readonly isMuxVideo: boolean | null;
  readonly videoAutoplay: boolean | null;
  readonly videoId: string | null;
  readonly " $fragmentType": "HpSharedVideoComponentVideo_componentModule";
};
export type HpSharedVideoComponentVideo_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponentVideo_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentVideo_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponentVideo_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoAutoplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMuxVideo",
      "storageKey": null
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "4ea4584ec4916a1e40a7e7eb25dd44f9";

export default node;
